// Path: D:\Projects\choice-platform\mcn-frontend\src\components\common\LoadingFallback.jsx

import React from 'react';

const LoadingFallback = ({ message = "Loading..." }) => {
  return (
    <div className="loading-container" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      flexDirection: 'column',
      background: 'var(--bg-color, white)'
    }}>
      <div className="loading-spinner" style={{
        width: '50px',
        height: '50px',
        border: '5px solid rgba(0, 0, 0, 0.1)',
        borderRadius: '50%',
        borderTop: '5px solid var(--primary-color, #3498db)',
        animation: 'spin 1s linear infinite'
      }}></div>
      <p style={{ marginTop: '20px', color: 'var(--text-color, #333)' }}>
        {message}
      </p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingFallback;